import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-account-tree-view-modal',
  templateUrl: './account-tree-view-modal.component.html',
  styleUrls: ['./account-tree-view-modal.component.scss'],
  standalone: false
})
export class AccountTreeViewModalComponent {
  @Input() hierarchicalAccounts: any[] = [];

  constructor() {
  }

  toggleSubtotal(subtotal: any) {
    subtotal.expanded = !subtotal.expanded;
  }

  expandAll() {
    this.hierarchicalAccounts.forEach(sub => sub.expanded = true);
  }

  collapseAll() {
    this.hierarchicalAccounts.forEach(sub => sub.expanded = false);
  }
}
